import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import { tabMapOptions } from "@/views/repository/resource/config/option";
import { parseTime } from "@/filters";
export default defineComponent({
    name: "table-group-modular",
    props: {
        resourceTable: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var filters = function(asset_type) {
            var ref;
            return (ref = tabMapOptions.find(function(item) {
                return item.value === asset_type;
            })) === null || ref === void 0 ? void 0 : ref.label;
        };
        var filterTime = function(time) {
            return parseTime(time, "{y}-{m}-{d} {h}:{i}:{s}");
        };
        var handleSortChange = function(order) {
            emit("handleSortChange", order);
        };
        var handleClickGroupOperation = function(row, type) {
            emit("handleClickGroupOperation", row, type);
        };
        return {
            tabMapOptions: tabMapOptions,
            filters: filters,
            filterTime: filterTime,
            handleSortChange: handleSortChange,
            handleClickGroupOperation: handleClickGroupOperation
        };
    }
});
